import React, { FC } from 'react';
import ListSubheader, { ListSubheaderProps } from '@material-ui/core/ListSubheader';
import { Uds } from '../../types';

export type MenuListSubHeaderProps = Uds<ListSubheaderProps & {}>;

export const MenuListSubHeader: FC<React.PropsWithChildren<MenuListSubHeaderProps>> = ({ dataTest, ...props }) => (
  <ListSubheader data-test={dataTest} {...props} />
);
